// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__rZxLu","content":"Consent_content__2k2N-","footer":"Consent_footer__1pINm"};